import Beautify from 'nginxbeautify';

const textarea = document.getElementById('textarea');
const form = document.getElementById('form');

form.addEventListener('submit', function (e) {
  e.preventDefault();
  const tabs = parseInt(document.getElementById('tabs').value);
  const spaces = parseInt(document.getElementById('spaces').value);
  const dontJoinCurlyBracet = document.getElementById('dontJoinCurlyBracet').checked;

  const beautifier = new Beautify({ spaces, tabs, dontJoinCurlyBracet});
  textarea.value = beautifier.parse(textarea.value);
  return false;
});
